import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox, FormControlLabel, FormGroup, Grid2, Stack, Typography, useTheme } from "@mui/material"
import { InvestigationButton, ModalContainer } from "../components"

export const PrintInvestigation = ({ show, onHide }) => {

  const theme = useTheme();
  const [t] = useTranslation("investigation");

  const [values, setValues] = useState([]);

  useEffect(() => {
    if (!show) {
      setTimeout(() => {
        setValues(sectionsOpts.map(item => item.value));
      }, 200);
    }
  }, [show]);

  function handleChange(value) {
    if (values.includes(value)) {
      setValues(values.filter(v => v !== value));
    } else {
      setValues([...values, value]);
    }
  }

  const sectionsOpts = [
    { label: t("sections.evaluation"), value: "evaluation" },
    { label: t("sections.locations"), value: "scenarios" },
    { label: t("sections.involved"), value: "involved" },
    { label: t("sections.activity_plan"), value: "plan" },
    { label: t("sections.resources"), value: "resources" },
    { label: t("sections.interviews"), value: "interviews" },
    { label: t("sections.evidences"), value: "evidences" },
    { label: t("sections.conclusion"), value: "conclusions" }
  ];

  return (
    <ModalContainer
      show={show}
      onHide={onHide}
    >
      {/* Header */}
      <Typography fontWeight={700} fontSize={28} color={theme.palette.ethicsBlue.main}>
        {t("modals.printInvestigation.title")}
      </Typography>
      <Typography fontSize={16} color="oxfordBlue" >
        {t("modals.printInvestigation.description")}
      </Typography>

      <hr />

      <Grid2 container spacing={2}>
        
        <Grid2 size={{ md: 6 }}>
          <Stack>
            {
              sectionsOpts.slice(0, Math.ceil(sectionsOpts.length / 2)).map((item) => (
                <CheckboxItem
                  key={item.value}
                  label={item.label}
                  value={item.value}
                  checked={values.includes(item.value)}
                  onChange={handleChange}
                />
              ))
            }
          </Stack>
        </Grid2>

        <Grid2 size={{ md: 6 }}>
          <Stack>
            {
              sectionsOpts.slice(Math.ceil(sectionsOpts.length / 2)).map((item) => (
                <CheckboxItem
                  key={item.value}
                  label={item.label}
                  value={item.value}
                  checked={values.includes(item.value)}
                  onChange={handleChange}
                />
              ))
            }
          </Stack>
        </Grid2>

      </Grid2>


      <Stack direction="row" spacing={2} mt={2} justifyContent="flex-end">
        <InvestigationButton
          label={t("modals.printInvestigation.cancel")}
          variant="main"
          outlined
          onClick={onHide}
          />
        <InvestigationButton
          label={t("modals.printInvestigation.print")}
          variant="main"
          onClick={onHide}
        />
      </Stack>

    </ModalContainer>
  )
}

const CheckboxItem = ({ label, value, checked, onChange, disabled }) => {
  const theme = useTheme();
  return (
    <FormGroup sx={{ width: 'fit-content' }}>
      <FormControlLabel 
        label={label} 
        sx={{
          '& .MuiTypography-root': { fontSize: 16, fontWeight: 600, color: theme.palette.secondary.main },
        }}
        control={ 
          <Checkbox
            sx={{ '& .MuiSvgIcon-root': { color: theme.palette.ethicsBlue.main } }} 
            size="small"
            checked={checked}
            onChange={()=>onChange(value)}
            disabled={disabled}
          />
        } 
      />
    </FormGroup>
  )
}